var _this = undefined;
/**
 * @function debounce
 * @description Debounce a function
 */
const debounce = (fn, delay) => {
  let timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(_this, args), delay);
  };
};

/**
 * @function throttle
 * @description Throttle a function
 */
const throttle = (fn, delay) => {
  let isWaiting = false;
  return function () {
    // Stop the function from calling again
    if (isWaiting) return;

    // Call function and set waiting to true
    fn(...arguments);
    isWaiting = true;

    // Tell the function how long to wait before executing again.
    setTimeout(() => {
      isWaiting = false;
    }, delay);
  };
};

export { debounce, throttle };
